import ApiClient from '@/api-client';

const localStorageToInvalidate = [
];

// eslint-disable-next-line no-unused-vars
export default async (to, from, next, store) => {
    const { data } = await ApiClient.get(`/version.json?hash=${Date.now()}`);

    if (localStorage.getItem('version') !== data || localStorage.getItem('version') < data) {
        localStorageToInvalidate.forEach((key) => store.dispatch('FilterStore/clearFilterFromStorage', key));
        localStorage.setItem('version', data);
    }
    if (COMMIT_HASH !== data) {
        // console.log('COMMIT_HASH', COMMIT_HASH);
    //    window.location.href = to.fullPath;
    }
};
